// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e2c38957","238":"c88cdf6e","295":"13aa7db4","309":"67a01991","330":"ff76afb0","453":"68693753","458":"86689c75","560":"aabeb7a9","572":"a401bc53","676":"21fd99b9","728":"545641ad","961":"dbcfbff0"}[chunkId] + ".chunk.js";
};